module.exports = __webpack_public_path__ + "static/media/puzzle-31-bg.ef1e6413.svg";